import React, { useState, useEffect, use } from 'react'
import { getCallTemplatesList, deleteCallTemplateById, getCallTemplateSearchBySubjectKeyword, SaveCallTemplateByData, UpdateCallTemplateByData, getcallTemplatecampaignsByData } from "../ActionCreator";
import Multiselect from "multiselect-react-dropdown";
import ReactQuill from "react-quill";
import ConfirmationPopup from "../../../../presentationals/Popup/ConfirmationPopup.component";
import NodataImage from '../../../../../images/nodata.png'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AddIcon from '@mui/icons-material/Add';
import Popup from '../../../../presentationals/Popup/Popup.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { COMPANY_NAME } from '../../../../../utils/api-factory';
const quillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        ["blockquote"],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
        ],
        [{ align: [] }],
        ["link", "image"],
    ],
};

const quillFormats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "background",
    "align",
];

const Email = ({ admin }) => {
    const [loader, setLoader] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [viewType, setViewType] = useState("list")
    const [showModal, setshowModal] = useState(false)
    const [editData, setEditData] = useState({})
    const [list, setList] = useState([])
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [deleteData, setDeleteData] = useState({})
    const [campaginList, setCampaignList] = useState([])
    const [leadList, setLeadList] = useState([])
    const [objectData, setObjectData] = useState({
        templateName: "",
        callPurpose: "",
        outbound: false,
        campaignId: "",
        leadId: "",
        campaignName: "",
        leadName: "",
    })

    useEffect(() => {
        getCallTemplatesListFn()
        getcallTemplatecampaignsByDataFn()
    }, []);

    const handlePage = (type, data) => {
        setViewType(type)
        if (type == "add") {
            setEditData(data)
            getcallTemplatecampaignsByDataFn()
            handleLeadData(data?.campaignId)
            setObjectData({
                templateName: data?.templateName || "",
                callPurpose: data?.callPurpose || "",
                outbound: data?.outbound || false,
                campaignId: data?.campaignId || "",
                leadId: data?.leadId || "",
                campaignName: data?.campaignName || "",
                leadName: data?.leadName || "",


            })

        } else if (type == "list") {
            getCallTemplatesListFn()
            setEditData({})
            setObjectData({
                templateName: "",
                callPurpose: "",
                outbound: false,
                campaignId: "",
                leadId: "",
                campaignName: "",
                leadName: "",
            })
        }
    }

    const getcallTemplatecampaignsByDataFn = () => {
        setLoader(true)
        getcallTemplatecampaignsByData(false,callback => {
            setLoader(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setCampaignList(callback?.data)
            } else {
                setCampaignList([])
            }

        })
    }

    const cancelLoanConfirm = (type) => {
        if (type == "yes") {
            deleteCallTemplateByIdFn(deleteData?.callId)
            setshowModal(false)
        } else if (type == "no") {
            setshowModal(false)
            setDeleteData({})
        }
    }

    const handleDelete = (data) => {
        setDeleteData(data)
        setshowModal(true)
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleSearchbtn = (e) => {
        if (e.key == "Enter" && searchValue?.length > 0) {
            getCallTemplateSearchBySubjectKeywordFn()
        }
    }

    const changeSearchValue = (e) => {
        setSearchValue(e.target.value)
        if (e.target.value == "") {
            getCallTemplatesListFn()
        }
    }

    const handleAddchange = (e, type) => {
        //  campaignName: objectData?.campaignName,
        //         leadName: objectData?.leadName,

        if (type == "campaignId") {
            const val = campaginList?.length > 0 ? campaginList?.filter((el) => el?.campaignId == e.target.value) : [];
            setObjectData((prev) => ({
                ...prev,
                ["campaignName"]: val[0]?.campaignName
            }))
        }
        if (type == "leadId") {
            const val = leadList?.length > 0 ? leadList?.filter((el) => el?.leadId == e.target.value) : [];
            setObjectData((prev) => ({
                ...prev,
                ["leadName"]: val[0]?.leadName
            }))
        }
        setObjectData((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleSave = (e) => {
        if (objectData?.templateName === "" || objectData?.templateName === null || objectData?.templateName === undefined) {
            setPopup({ show: true, popupStatus: "Please Enter Template Name" })
            removePopup()
        } else if (objectData?.campaignId === "" || objectData?.campaignId === null || objectData?.campaignId === undefined) {
            setPopup({ show: true, popupStatus: "Please Select Campaign" })
            removePopup()
        } else if (objectData?.leadId === "" || objectData?.leadId === null || objectData?.leadId === undefined) {
            setPopup({ show: true, popupStatus: "Please Select lead" })
            removePopup()
        } else if (editData?.callId) {
            // update Fn
            const obj = {
                  templateName: objectData?.templateName,
                callPurpose: objectData?.callPurpose,
                outbound: objectData?.outbound,
                campaignId: objectData?.campaignId,
                leadId: objectData?.leadId,
                campaignName: objectData?.campaignName,
                leadName: objectData?.leadName,
                "companyName": COMPANY_NAME,
            }
            UpdateCallTemplateByDataFn(editData?.callId, obj)

        } else {
            const obj = {
                templateName: objectData?.templateName,
                callPurpose: objectData?.callPurpose,
                outbound: objectData?.outbound,
                campaignId: objectData?.campaignId,
                leadId: objectData?.leadId,
                campaignName: objectData?.campaignName,
                leadName: objectData?.leadName,
                "companyName": COMPANY_NAME,
            }
            SaveCallTemplateByDataFn(obj)
        }
    }


    const getCallTemplatesListFn = () => {
        setLoader(true)
        getCallTemplatesList("", callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
                setList(callback?.data)
            } else {
                setList([])
            }
        })
    }

    const deleteCallTemplateByIdFn = (id) => {
        setLoader(true)
        deleteCallTemplateById(id, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Template Deleted Successfully" })
                getCallTemplatesListFn()
                setDeleteData({})
            } else {
                setPopup({ show: true, popupStatus: "Error Deleting Template" })
                setDeleteData({})
            }
            removePopup()
        })
    }

    const getCallTemplateSearchBySubjectKeywordFn = () => {
        setLoader(true)
        getCallTemplateSearchBySubjectKeyword(searchValue, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
                setList(callback?.data)
            } else {
                setList([])
            }
        })
    }

    const SaveCallTemplateByDataFn = (data) => {
        setLoader(true)
        SaveCallTemplateByData(data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Saved Successfully" })
            } else if (callback?.data !== null) {
                setPopup({ show: true, popupStatus: callback?.data })
            } else {
                setPopup({ show: true, popupStatus: "Error Saving Data" })
            }
            removePopup()
        })
    }
    const UpdateCallTemplateByDataFn = (id, data) => {
        setLoader(true)
        UpdateCallTemplateByData(id, data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Updated Successfully" })
            } else if (callback?.data !== null) {
                setPopup({ show: true, popupStatus: callback?.data })
            } else {
                setPopup({ show: true, popupStatus: "Error Updating Data" })
            }
            removePopup()
        })
    }

    const handleLeadData = (value) => {
        setLeadList([])
        setObjectData((prev) => ({ ...prev, leadId: '', leadName: '' }))
        const ar = campaginList?.length > 0 ? campaginList?.filter((el) => el?.campaignId == value) : []
        console.log("wdee", ar?.leads?.length > 0 ? ar?.[0]?.leads : [])
        setLeadList(ar?.[0]?.leads?.length > 0 ? ar?.[0]?.leads : [])
    }



    return (
        <>
            <div className="container-fluid marketing-main-css" style={{ margin: '100px 0 40px 0' }}>
                {
                    loader ?
                        <Loader /> : ''
                }
                {showModal ?
                    <ConfirmationPopup cancelLoanConfirm={cancelLoanConfirm} confirmationText={'Are you sure you want to delete this template?'} />
                    : ""}

                {popup?.show ?
                    <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} />
                    : ''}

                <div className="row">
                    <div style={{ display: 'flex', marginBottom: '20px' }}>

                        <button onClick={() => handlePage('list', "")} className="btn" style={{ minWidth: '40px', color: viewType === "list" ? "#fff" : "#000", background: viewType === "list" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex', margin: '0 16px' }}>
                            <FormatListBulletedIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                        <button onClick={() => handlePage('add', "")} className="btn " style={{ minWidth: '40px', color: viewType === "add" ? "#fff" : "#000", background: viewType === "add" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex' }}>
                            <AddIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                    </div>

                    {viewType === 'list' ?
                        <div className="col-sm-12 col-xs-12">
                            <div className="row" style={{ marginTop: '15px' }}>
                                <div className="col-lg-2 col-sm-3 col-xs-4">
                                    <label htmlFor=""><i class="fa fa-search" aria-hidden="true"></i>&nbsp;Search</label>
                                    <input className='form-control' placeholder='Search by Subject' type='search' value={searchValue} onChange={(e) => changeSearchValue(e)} onKeyDown={(e) => handleSearchbtn(e)} />
                                </div>
                            </div>
                            <hr />
                            {list !== '' && list?.length > 0 ?
                                <>
                                    <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '15px' }}>
                                        <table>
                                            <thead>

                                                <tr>
                                                    <th className='text-center'>Template Name</th>
                                                    <th className='text-center'>Call Purpose</th>
                                                    <th className='text-center'>Outbound</th>
                                                    <th className='text-center'>Campaign Name</th>
                                                    <th className='text-center'>Lead Name</th>
                                                    <th className='text-center'>Added On</th>
                                                    <th className='text-center'>Edit</th>
                                                    <th className='text-center'>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list && list?.length > 0 ? list?.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{data?.templateName}</td>
                                                        <td className='text-center'>{data?.callPurpose}</td>
                                                        <td className='text-center'>{data?.outbound ? "Yes" : "No"}</td>
                                                        <td className='text-center'>{data?.campaignName}</td>
                                                        <td className='text-center'>{data?.leadName}</td>
                                                        <td className='text-center'>{data?.creationDate}</td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-edit" onClick={() => handlePage('add', data)}></i></td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-trash" onClick={() => handleDelete(data)}></i></td>
                                                    </tr>
                                                )) : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                                :
                                <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>}


                        </div>
                        : ""}


                    {viewType === 'add' ?
                        <div className="col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="shadow" style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,.2)', padding: '15px', borderRadius: '6px' }}>
                                <h4 style={{ marginTop: '10px', fontSize: '16px' }}><b>Configure Call Template</b></h4>
                                <hr style={{ color: '#c7c8c9', borderTop: '3px solid #c7c8c9' }} />


                                <div className="row" style={{ marginTop: '40px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Template Name</label>
                                        <input type='text' className='form-control' value={objectData?.templateName} onChange={(e) => handleAddchange(e, "templateName")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Call Purpose</label>
                                        <input type='text' className='form-control' value={objectData?.callPurpose} onChange={(e) => handleAddchange(e, "callPurpose")} />
                                    </div>

                                    <div className="col-sm-4 col-xs-12">
                                        <label>Outbound ?</label>
                                        <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                            <label class="switch">
                                                <input type="checkbox" class="checkbox"
                                                    checked={objectData.outbound}
                                                    onChange={(e) =>
                                                        setObjectData((prev) => ({
                                                            ...prev,
                                                            outbound: e.target.checked,
                                                        }))
                                                    }
                                                />
                                                <div class="slider"></div>
                                            </label>
                                        </div>
                                    </div>

                                </div>

                                <div className="row" style={{ marginTop: '30px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Campaign</label>
                                        <select className='form-control' value={objectData?.campaignId} onChange={(e) => { handleAddchange(e, "campaignId"); handleLeadData(e.target.value); }}>
                                            <option>Select option</option>
                                            {
                                                campaginList?.length > 0 ? campaginList?.map((val, id) => {
                                                    return (
                                                        <option value={val?.campaignId}>{val?.campaignName}</option>
                                                    )
                                                })
                                                    : ''}
                                        </select>

                                    </div>
                                    {
                                        leadList?.length > 0 ?
                                            <div className="col-sm-4 col-xs-12">
                                                <label>Lead</label>
                                                <select className='form-control' value={objectData?.leadId} onChange={(e) => handleAddchange(e, "leadId")}>
                                                    <option>Select option</option>
                                                    {
                                                        leadList?.map((val, id) => {
                                                            return (
                                                                <option value={val?.leadId}>{val?.leadName}</option>
                                                            )
                                                        })
                                                    }

                                                </select>

                                            </div>
                                            : ''}
                                </div>

                                <div className="row" style={{ marginTop: '30px' }}>
                                    <div className="col-xs-12 text-center">
                                        <button className='btn' style={{ padding: '10px 15px', borderRadius: '6px', background: '#337ab7', color: '#fff' }} onClick={(e) => handleSave(e)}>Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        : ""}
                </div>


            </div>
        </>
    )
}

export default Email;
